import { agreeOnTerms } from '../utilities/api'

// ==================================================================================================
//
// Opt In Popup Functionality
//
// ==================================================================================================

const updatedHomeClubPopup = () => {
    let props = { isEnabled : false };
    let els = {};

    // Cache dom element selectors
    // ------------------------------------------------
    const createChildren = () => {
      els.$updatedHomeClubPopupWrapper  = $('#updatedHomeClubPopupWrapper')
      els.$updatedHomeClubCancelButton = $('#updatedHomeClubCancelButton')
      els.$updatedHomeClubAcceptButton = $('#updatedHomeClubAcceptButton')
    }

    const hidePopup = isWrapperClicked => e => {
        els.$updatedHomeClubPopupWrapper[0].classList.remove('shown')
    }
    
    // Set up for responsive
    // ------------------------------------------------
    const setupResponsive = () => ({
        'sm' : enable,
        'md' : enable,
        'lg' : enable,
        'xl' : enable
    })

    // Enable
    // ------------------------------------------------
    const enable = () => {
        if (props.isEnabled) return;
        // Add your event handlers here
        els.$updatedHomeClubCancelButton.on('click', hidePopup(true))
        els.$updatedHomeClubAcceptButton.on('click', hidePopup(true))
        // els.$updatedHomeClubPopupWrapper.on('click', hidePopup())
        props.isEnabled = true;
        return;
    }

    // Disable
    // ------------------------------------------------
    const disable = () => {
        if (!props.isEnabled) return;
        // Remove your event handlers here
        props.isEnabled = false;
        return;
    }

    // Init
    // ------------------------------------------------
    const init = () => {
        createChildren();
        setupResponsive();
        return;
    }

    return {
        init,
        enable,
        disable,
        responsiveCallbacks: setupResponsive()
    };
}

export default updatedHomeClubPopup;
